var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "status-details" }, [
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n      Nessa etapa a carteira do profissional está sendo criada junto ao nosso\n      meio de pagamento.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "events" }, [
        _c(
          "ul",
          _vm._l(_vm.events, function(event) {
            return _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm._f("getStatusName")(_vm.eventName(event.event_type))
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formattedDate(event.created_at)))])
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _vm.isPGACreationFailed
          ? _c(
              "v-btn",
              {
                attrs: { color: "primary", small: "", loading: _vm.preloader },
                on: { click: _vm.createProfessionalPGAOnGateway }
              },
              [
                _vm._v(
                  "\n      Criar conta do profissional no meio de pagamento\n    "
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6682296", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6682296","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Register/Steps/PGA.vue
// module id = null
// module chunks = 